import ActivitiesTable from './activities-table';

export default ActivitiesTable;
